import type { DayOfWeek } from '@/shared/enums/DayOfWeekEnum'
import type { ShiftType } from '../enums/ShiftType'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class CreateUpdateShiftTemplateEntity {
  dayOfWeek?: DayOfWeek
  startTimeDate?: Date
  startTimeDayOfWeek?: DayOfWeek
  durationDate?: Date
  size?: number
  region?: RegionMiniEntity
  shiftType?: ShiftType
}
